import { render, staticRenderFns } from "./positionad.vue?vue&type=template&id=608fb5dd&scoped=true"
import script from "./positionad.vue?vue&type=script&lang=js"
export * from "./positionad.vue?vue&type=script&lang=js"
import style0 from "./positionad.vue?vue&type=style&index=0&id=608fb5dd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608fb5dd",
  null
  
)

export default component.exports